<template>
  <CSelect
    class="w-auto"
    :consistent-menu-width="false"
    :options="listOptions"
    :renderLabel="renderLabel"
    :showCheckmark="false"
    :value="getListValue"
    @update:value="toggleList($event)"
  />
</template>

<script lang="ts" setup>
import type { VNode } from 'vue'
import { computed } from 'vue'
import type { Option } from '@lib/components/CRichTextEditor/components/CEditorMenu.vue'
import type { Editor } from '@tiptap/vue-3'
import CSelect from '@lib/components/CSelect/CSelect.vue'
import { useI18n } from 'vue-i18n'

enum List {
  NONE = 'none',
  CHECK = 'check',
  BULLET = 'bullet',
  NUMBER = 'number',
}

interface Props {
  editor: Editor
  renderLabel: (option: Option) => VNode
}

const props = defineProps<Props>()
const { t } = useI18n()

const listOptions: Option[] = [
  {
    icon: 'list',
    label: t('canvasUI.CRichTextEditor.bullet'),
    value: List.BULLET,
  },
  {
    icon: 'list-ol',
    label: t('canvasUI.CRichTextEditor.number'),
    value: List.NUMBER,
  },
  //  todo
  // {
  //   icon: 'list-check',
  //   label: List.CHECK,
  //   value: List.CHECK,
  // },
  {
    icon: 'bars',
    label: t('canvasUI.CRichTextEditor.none'),
    value: List.NONE,
  },
]

const getListValue = computed(() => {
  if (props.editor.isActive('bulletList')) {
    return List.BULLET
  } else if (props.editor.isActive('orderedList')) {
    return List.NUMBER
  } else {
    return List.NONE
  }
})

const toggleList = (value: List) => {
  switch (value) {
    case List.NONE:
      if (props.editor.isActive('orderedList')) {
        props.editor.chain().focus().toggleOrderedList().run()
      } else if (props.editor.isActive('bulletList')) {
        props.editor.chain().focus().toggleBulletList().run()
      }
      break
    case List.CHECK:
      // todo
      // props.editor.chain().focus().toggleList().run()
      break
    case List.NUMBER:
      props.editor.chain().focus().toggleOrderedList().run()
      break
    case List.BULLET:
      props.editor.chain().focus().toggleBulletList().run()
      break
    default:
  }
}
</script>
